import { makeStyles } from 'tss-react/mui';

const useStylesCheckboxSelectAll: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  checkboxSelectAll: {
    top: -1,
    zIndex: 1000,
    padding: '3px 4px !important',
    marginLeft: '12px !important',
    marginRight: '7px !important',
    [theme.breakpoints.down('md')]: {
      marginLeft: '16px !important',
    },
  },
  checkboxSelectAllCard: {
    marginLeft: '17px !important',
  },
}));

export default useStylesCheckboxSelectAll;
